// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.review-card {
  width: 25%;
  background-color: #f8f8f8;
  margin: 1%;
  padding: 0%;
  text-align: center;
  cursor: pointer;
}

.header-style {
  background-color: #c00;
  color: white;
  width: 100%;
  height: 35px;
  padding-top: 4px;
}

.mat-mdc-card-image {
  display: inline;
}
.mat-mdc-card-image:first-child {
  margin-top: 5px !important;
  border-top-left-radius: inherit !important;
  border-top-right-radius: inherit !important;
}

.image-style {
  padding-top: 3%;
  width: 35%;
}

.home-container {
  max-height: calc(100vh - 145px);
  overflow: auto;
  height: calc(100vh - 145px);
}
.home-container .review-card.disable-card {
  opacity: 0.5;
  cursor: auto;
}
.home-container .home-inner-container {
  height: 100%;
}
.home-container .home-inner-container .home-inner-container-first {
  height: 100%;
  margin-top: 25px;
}
.home-container .home-inner-container .home-inner-container-two {
  height: 100%;
  margin-bottom: 25px;
}`, "",{"version":3,"sources":["webpack://./src/app/feature/home/home.component.scss"],"names":[],"mappings":"AAAA;EACI,UAAA;EACA,yBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;AACJ;;AAEA;EACI,sBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AACJ;;AAMA;EACI,eAAA;AAHJ;AAKI;EACI,0BAAA;EACA,0CAAA;EACA,2CAAA;AAHR;;AAOA;EACI,eAAA;EACA,UAAA;AAJJ;;AAOA;EACI,+BAAA;EACA,cAAA;EACA,2BAAA;AAJJ;AAMI;EACI,YAAA;EACA,YAAA;AAJR;AAOI;EACI,YAAA;AALR;AAOQ;EACI,YAAA;EACA,gBAAA;AALZ;AAOQ;EACI,YAAA;EACA,mBAAA;AALZ","sourcesContent":[".review-card{\n    width: 25%;\n    background-color: #f8f8f8;\n    margin: 1%;\n    padding: 0%;\n    text-align: center;\n    cursor: pointer;\n}\n\n.header-style{\n    background-color: #c00;\n    color: white;\n    width: 100%;\n    height: 35px;\n    padding-top: 4px;\n}\n\n// .content-style{\n//     height: 150px;\n// }\n\n.mat-mdc-card-image {\n    display: inline;\n    \n    &:first-child {\n        margin-top: 5px !important;\n        border-top-left-radius: inherit !important;\n        border-top-right-radius: inherit !important;\n    }\n}\n\n.image-style{\n    padding-top: 3%;\n    width: 35%;\n}\n\n.home-container{\n    max-height: calc(100vh - 145px);\n    overflow: auto;\n    height: calc(100vh - 145px);\n\n    .review-card.disable-card {\n        opacity: 0.5;\n        cursor: auto;\n    }\n\n    .home-inner-container {\n        height: 100%;\n\n        .home-inner-container-first {\n            height: 100%;\n            margin-top: 25px;\n        }\n        .home-inner-container-two {\n            height: 100%;\n            margin-bottom: 25px;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
